const ModalTypes = {
  EDD_PINCODE: 'edd-pincode',
  EDD_MOVE_TO_CLOEST: 'edd-move-to-closet'
};

export default ModalTypes;
